defineDs('DanskeSpil/Domain/NumberGames/Scripts/Components/CurrentJackpots/CurrentJackpots', [
  'Shared/Framework/Mithril/Scripts/Core/Component',
  'DanskeSpil/Framework/PuljeFeed/Scripts/JackpotInfo',
  'DanskeSpil/Domain/NumberGames/Scripts/Components/CurrentJackpots/Game',
  'DanskeSpil/Domain/NumberGames/Scripts/Components/CurrentJackpots/ApplyRowBasedClasses'

], function (Component, JackpotInfo, GameItem, ApplyRowBasedClasses) {
  Component('current-jackpots', function (m, route, settings, ignoreProperty, $element) {

    const root = {
      controller: function () {
        // variables
        this.title = settings.title;
        this.text = settings.text;
        let games = [];

        const iconPath = '/Components/DanskeSpil/Domain/Subscriptions/Graphics/SpriteSheets/WizardGameIcons/';
        const logoPath = '/Components/DanskeSpil/Domain/Subscriptions/Graphics/WizardGameLogos/';

        settings.gameOrder.forEach((game, index) => {
          switch (game) {
          case 'lotto':
            games.push(m(GameItem,
              { index: (index + 1),
                game: game,
                icon: iconPath + 'lotto.svg',
                logo: logoPath + 'lotto-white.svg',
                poolLabel: settings.labelMinPoolSizeText,
                poolValue: (JackpotInfo.getByGame(game)?.poolSize || JackpotInfo.getByGame(game)?.minimumPoolSize) + ' MIO',
                btnText: settings.labelCtaButtonText,
                btnCta: settings.lottoLink
              }));
            break;
          case 'eurojackpot':
            games.push(m(GameItem,
              { index: (index + 1),
                game: game,
                icon: iconPath + 'eurojackpot.svg',
                logo: logoPath + 'eurojackpot-white.svg',
                poolLabel: settings.labelMinPoolSizeText,
                poolValue: (JackpotInfo.getByGame(game)?.poolSize || JackpotInfo.getByGame(game)?.minimumPoolSize) + ' MIO',
                btnText: settings.labelCtaButtonText,
                btnCta: settings.eurojackpotLink
              }));
            break;
          case 'vikinglotto':

            games.push(m(GameItem,
              { index: (index + 1),
                game: game,
                icon: iconPath + 'vikinglotto.svg',
                logo: logoPath + 'vikinglotto-white.svg',
                poolLabel: settings.labelMinPoolSizeText,
                poolValue: (JackpotInfo.getByGame(game)?.poolSize || JackpotInfo.getByGame(game)?.minimumPoolSize) + ' MIO',
                btnText: settings.labelCtaButtonText,
                btnCta: settings.vikinglottoLink
              }));
            break;
          case 'keno':
            games.push(m(GameItem,
              { index: (index + 1),
                game: game,
                icon: iconPath + 'keno.svg',
                logo: logoPath + 'keno-white.svg',
                poolLabel: settings.labelKenoText,
                poolValue: settings.kenoValue,
                btnText: settings.labelCtaButtonText,
                btnCta: settings.kenoLink
              }));
            break;
          case 'allornothing':
            games.push(m(GameItem,
              { index: (index + 1),
                game: game,
                icon: iconPath + 'allornothing.svg',
                logo: logoPath + 'allornothing-white.svg',
                poolLabel: settings.labelAllOrNothingText,
                poolValue: settings.allOrNothingValue,
                btnText: settings.labelCtaButtonText,
                btnCta: settings.allOrNothingLink
              }));
            break;
          default:
            break;
          }
        });

        this.games = games;

        const initateAnimation = () => {
          const boxes = $element.querySelectorAll('.current-jackpots__game');
          const randomIndex = Math.floor(Math.random() * boxes.length);
          const selectedBox = boxes[randomIndex];

          selectedBox?.classList.add('current-jackpots__game--animate');
          try {
            selectedBox.onanimationend = (event) => {
              const animationName = event.animationName;
              if (animationName === 'currentjackpots-animation') {
                selectedBox.classList.remove('current-jackpots__game--animate');
              }
            };
          } catch { (exception) => console.log(exception); }
        };

        setInterval(() => {
          initateAnimation();
        }, 4000);


        this.currentJackpotConfig = ($element, isInitialized) => {
          if (!isInitialized) {
            setTimeout(() => {
              ApplyRowBasedClasses.apply($element.querySelector('.current-jackpots__games'), $element.querySelectorAll('.current-jackpots__game'), {
                3: { 2: 'current-jackpots__game-lower-1' },
                4: { 2: 'current-jackpots__game-lower-1', 3: 'current-jackpots__game-lower-1' },
                5: { 2: 'current-jackpots__game-lower-1', 4: 'current-jackpots__game-lower-1', 3: 'current-jackpots__game-lower-2' }
              });
            });
          }
        };
      },

      view: function (controller) {
        return m('.current-jackpots', {
          config: controller.currentJackpotConfig
        }, [
          (controller.title || controller.text) ? [
            controller.title ? m('h3.current-jackpots__title', controller.title) : null,
            controller.text ? m('.current-jackpots__text', m.trust(controller.text)) : null,
          ] : '',
          m('.current-jackpots__games', [
            controller.games
          ])
        ]);
      }
    };

    route('/', root);
  });
});
